import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMRoomExceptionResource {
  static postException(formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_exceptions.json" + q;  
    const apiClient = new SMRestClient();
    apiClient.post(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static updateException(id, formData, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_exceptions/" + id + ".json" + q;  
    const apiClient = new SMRestClient();
    apiClient.patch(url, formData).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
  
  static deleteException(id, queries, completion){
    const q = SMFormatHelper.getUrlArgString(queries);
    const url = "/1/room_exceptions/" + id + ".json" + q;
    const apiClient = new SMRestClient();
    apiClient.destroy(url).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
}
export default SMRoomExceptionResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMRoomExceptionResource.js